export default "__VITE_ASSET__3k5B5UjZ__"